document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const headerOffset = 100; // Offset from the top when scrolling to sections
  const intersectionThreshold = 0.5; // How much of the section needs to be visible

  // Get DOM elements
  const stickyMenu = document.querySelector('.sticky_menu');
  const websiteHeader = document.querySelector('.header--has-menu');
  const bannerContent = document.querySelector('.banner__content');
  
  // Early exit if essential elements are missing
  if (!stickyMenu || !websiteHeader || !bannerContent) {
    console.warn('Some essential elements for the sticky menu are missing');
    return;
  }

  // Calculate sticky menu offset based on header height
  const stickyMenuOffset = websiteHeader.offsetHeight;
  
  // Get all menu items (both regular and sticky versions)
  const menuItems = {};
  const sections = {};
  
  // Function to initialize menu items and sections
  function initializeMenuAndSections() {
    // Find all menu items and corresponding sections
    const regularMenuLinks = document.querySelectorAll('.custom_menu-nav__list-wrapper-scroll:not(.sticky_menu) .custom_menu-nav__item a');
    const stickyMenuLinks = document.querySelectorAll('.sticky_menu .custom_menu-nav__item a');
    
    // Process each menu link
    regularMenuLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const sectionId = href.substring(1); // Remove the # character
        
        // Store the menu items in our structure
        if (!menuItems[sectionId]) {
          menuItems[sectionId] = {
            regular: link,
            sticky: null
          };
        } else {
          menuItems[sectionId].regular = link;
        }
        
        // Find the corresponding section
        const section = document.querySelector(`.${sectionId}`);
        if (section) {
          sections[sectionId] = section;
        }
      }
    });
    
    // Process sticky menu links
    stickyMenuLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const sectionId = href.substring(1);
        
        if (!menuItems[sectionId]) {
          menuItems[sectionId] = {
            regular: null,
            sticky: link
          };
        } else {
          menuItems[sectionId].sticky = link;
        }
      }
    });
  }
  
  // Call the initialization function
  initializeMenuAndSections();
  
  // Set up banner intersection observer for sticky menu
  const bannerObserver = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting) {
      // Banner is not visible, show the sticky menu
      stickyMenu.style.display = "block";
      stickyMenu.style.position = 'fixed';
      stickyMenu.style.top = '0';
      stickyMenu.style.left = '0';
      stickyMenu.style.marginTop = stickyMenuOffset - 0.5 + "px";
      stickyMenu.style.zIndex = '2';
      stickyMenu.style.background = '#FFFFFF';
      stickyMenu.style.width = '100%';
    } else {
      // Banner is visible, hide the sticky menu
      stickyMenu.style.display = "none";
    }
  }, { threshold: [0] });
  
  // Start observing the banner
  bannerObserver.observe(bannerContent);
  
  // Add click event listeners to all menu items
  Object.keys(menuItems).forEach(sectionId => {
    const items = menuItems[sectionId];
    const section = sections[sectionId];
    
    if (!section) {
      console.warn(`Section with id ${sectionId} not found`);
      return;
    }
    
    // Add click event to regular menu item
    if (items.regular) {
      items.regular.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: section.offsetTop - headerOffset,
          behavior: 'smooth'
        });
      });
    }
    
    // Add click event to sticky menu item
    if (items.sticky) {
      items.sticky.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
          top: section.offsetTop - headerOffset,
          behavior: 'smooth'
        });
      });
    }
    
    // Set up intersection observer for this section
    const sectionObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        // This section is visible, highlight its menu items
        Object.keys(menuItems).forEach(id => {
          const menuItem = menuItems[id];
          
          if (id === sectionId) {
            // Highlight this section's menu items
            if (menuItem.regular) {
              menuItem.regular.style.fontWeight = "bold";
              /*menuItem.regular.style.textDecoration = "underline";*/
            }
            if (menuItem.sticky) {
              menuItem.sticky.style.fontWeight = "bold";
              /*menuItem.sticky.style.textDecoration = "underline";*/
            }
          } else {
            // Remove highlight from other menu items
            if (menuItem.regular) {
              menuItem.regular.style.fontWeight = "normal";
              menuItem.regular.style.textDecoration = "none";
            }
            if (menuItem.sticky) {
              menuItem.sticky.style.fontWeight = "normal";
              menuItem.sticky.style.textDecoration = "none";
            }
          }
        });
      }
    }, { threshold: intersectionThreshold });
    
    // Start observing this section
    sectionObserver.observe(section);
  });
});